// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"131":"3a391a01","194":"e79f93aa","260":"befbe170","668":"cd2a6d5a","675":"fb538f50","762":"d7ee5701","811":"7220e6f5","902":"52292f23","973":"3c4e1cdd","983":"7ce1641b"}[chunkId] + ".js";
};